export default __webpack_public_path__ + "images/bar-growth.8a8b7ee2a8de63eefcded9cce13c8f81.png";